module.exports = __webpack_public_path__ + "assets/img/48@3x.ae73012d.png";